import { initializeSprinkles } from '../../_shared-react/sprinkles';
import { initBugsnag } from './config/bugsnag';

initBugsnag();

const getComponentContext = () => require.context('./', true, /\.(\/index)?js$/);
initializeSprinkles(getComponentContext);
